import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/dashboard")


const getOrganisations = () => http.get("/organisations");
const getOrganisation = (id) => http.get("/organisations/" + id);
const newOrganisation = (body) => http.post("/organisations", body);
const updateOrganisation = (id, body) => http.put("/organisations/" + id, body);
const deleteOrganisation = (id) => http.delete("/organisations/" + id);
const putOrganisationVisibility = (organisation_id, body) => http.put(`/organisation_hidden/${organisation_id}`, body)
const updateOrganisationLogo = (body) => http.post("/organisation_logo", body);
const getDemoOrganisations = () => http.get("/demo_organisations");
const getDemoOrganisation = (id) => http.get(`/demo_organisations/${id}`)

export default {
    getOrganisations,
    getOrganisation,
    newOrganisation,
    updateOrganisation,
    deleteOrganisation,
    putOrganisationVisibility,
    updateOrganisationLogo,
    getDemoOrganisation,
    getDemoOrganisations
}